import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import App from './App.tsx';

// Extend dayjs plugins globally (once at startup)
dayjs.extend(relativeTime);

// Import Tailwind CSS
import './styles/tailwind.css';

// Render the main app
ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
